export const deals = {
  title: 'Ügyletek',
  subtitle: 'Üzletek és megállapodások kezelése',
  new: 'Új ügylet',
  view: 'Ügylet megtekintése',
  edit: 'Ügylet szerkesztése',
  noDeals: 'Nincs ügylet',
  fields: {
    type: 'Típus',
    customer: 'Ügyfél',
    assignedUser: 'Felelős felhasználó',
    date: 'Dátum',
    followUpDate: 'Következő lépés dátuma',
    description: 'Leírás',
    outcome: 'Eredmény',
    subject: 'Tárgy',
    duration: 'Időtartam',
    status: 'Státusz',
    minutes: 'Perc',
    notSet: 'Nincs beállítva',
    noAssignedUser: 'Nincs hozzárendelve',
    otherOrganization: 'más szervezet',
  },
  status: {
    completed: 'Kész',
    pending: 'Függőben',
    rejected: 'Elutasítva',
  },
  types: {
    phone: 'Telefon',
    email: 'Email',
    sms: 'SMS',
  },
  messages: {
    notSet: 'Nincs beállítva',
    updated: 'Ügylet sikeresen frissítve',
    created: 'Ügylet sikeresen létrehozva',
    deleted: 'Ügylet sikeresen törölve',
    userAssigned: 'Felelős felhasználó sikeresen hozzárendelve',
    error: 'Hiba történt a ügylet létrehozása közben',
    confirmTitle: 'Ügylet törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt az ügyletet?',
    deleteWarning: 'Ez a művelet nem visszavonható.'
  }
}